module.exports = __webpack_public_path__ + "img/new2.7a4680a8.jpg";